import { Wallet } from 'lucide-react';
import { Button, Kbd } from '@/components/ui';
import { openCashPayout } from './payoutStore';

/** "Cash out" button for the top bar (opens the global payout dialog; Alt+E does the same). */
export function CashOutButton() {
  return (
    <Button
      variant="outline"
      size="sm"
      leftIcon={<Wallet className="size-4" />}
      onClick={openCashPayout}
      title="Cash paid out (Alt+E)"
      className="shrink-0"
    >
      <span className="hidden sm:inline">Cash out</span>
      <span className="sr-only sm:hidden">Cash paid out</span>
      <Kbd keys="alt+e" className="hidden lg:inline-flex" />
    </Button>
  );
}
